import { isEmpty } from 'lodash'
import { mapActivity } from '../dashboard/helpers'
import { mapTaxonomyBreakdown } from './helpers'

const mutations = {
    setActiveStatus: (state, status) => {
        state.activeStatus = status
    },
    setIsExpiringAudiences: (state, expired) => {
        state.isExpiringAudiences = expired
    },
    setActiveTransfers: (state, status) => {
        state.activeTransfers = status
    },
    setIsExpiringTransfers: (state, expired) => {
        state.isExpiringTransfers = expired
    },
    setCcloneList: (state, cclones) => {
        state.ccloneList = cclones
    },
    setLoading: (state, loading) => {
        state.loading = loading
    },
    setExpiringAudiences: (state, count) => {
        state.expiringAudiences = count
    },
    setExpiringAudiencesError: (state, count) => {
        state.expiringAudiencesError = count
    },
    setExpiringAudiencesLoading: (state, loading) => {
        state.expiringAudiencesLoading = loading
    },
    setExpiringTransfers: (state, count) => {
        state.expiringTransfers = count
    },
    setExpiringTransfersError: (state, error) => {
        state.expiringTransfersError = error
    },
    setExpiringTransfersLoading: (state, loading) => {
        state.expiringTransfersLoading = loading
    },
    setBreakdown: (state, payload) => {
        const orders = {
            age: {
                'Aged 18 to 24': {
                    color:'#4498E2',
                    name: '18-24'
                },
                'Aged 25 to 34': {
                    color:'#4048EF',
                    name: '25-34'
                },
                'Aged 35 to 49': {
                    color:'#2DC9EB',
                    name: '35-49'
                },
                'Aged 50 to 64': {
                    color:'#809FB8',
                    name: '50-64'
                },
                'Aged 65 and more': {
                    color:'#645AFF',
                    name: '65+'
                } 
            },
            education: {
                'Undergraduate': null,
                'School / High School': null,
                'Postgraduate': null,
                'Professional Education': null
            },
            income: {
                'Income Top': null,
                'Income Higher': null,
                'Income High': null,
                'Income Mid': null,
                'Income Low': null,
            },
            gender: {
                Female: {
                    color: '#786AF4',
                    formatter: '<div class="content-tooltip"><span class="tooltip-gender female"></span><span class="tooltip-value">{c} %</span></div>'

                },
                Male: {
                    color: '#33A6FF',
                    formatter: '<div class="content-tooltip"><span class="tooltip-gender male"></span><span class="tooltip-value">{c} %</span></div>'
                }
            }
        }
        const generateDate = (obj, category) => {
            const data = []
            for(const key in orders[category]) {
                const item = {
                    name: key,
                    value: Math.round(obj[key].volume),
                    tooltip: {
                        trigger: 'item',
                        formatter: '<div class="content-tooltip"><span>{b} : </span><span class="tooltip-value">{c} %</span></div>',
                        borderColor: 'white'
                    }
                }
                if(category === 'age') {
                    item.name = orders.age[key].name
                    item['itemStyle'] = {
                        color: orders.age[key].color
                    }
                }
                if(category === 'gender') {
                    item.tooltip.formatter = orders.gender[key].formatter
                    item['itemStyle'] = {
                        color: orders.gender[key].color
                    }
                }
                data.push(item)
            }
            return data
        }
        for(const key in payload) {
            state.breakdown[key] = generateDate(payload[key], key)
        }
    },
    setBreakdownLoading(state, loading) {
        state.breakdownLoading = loading
    },
    setAllocationData(state, { data }) {
        state.allocationData = mapActivity(data)
    },
    setKibanaData(state, { data }) {
        state.kibanaData = data
    },
    setAllocationDataTimeUnit(state, { timeUnit }) {
        state.currentAllocationTimeUnit = timeUnit
    },
    setPercentBreakdown(state, percent) {
        if (isEmpty(percent)) state.percentBreakdown = []
        else {
            state.percentBreakdown = mapTaxonomyBreakdown('cluster_in_segment', 10, percent)
        } 
    },
    setAffinityBreakdown(state, affinity) {
        if (isEmpty(affinity)) state.affinityBreakdown = []
        else {
            state.affinityBreakdown = mapTaxonomyBreakdown('affinity', 10, affinity)
        } 
    },
    setCollectOffline(state, collect) {
        state.collectOffline = collect
    },
    setCollectOfflineLoading(state, loading) {
        state.collectOfflineLoading = loading
    },
    setCollectOnline(state, collect) {
        state.collectOnline = collect
    },
    setCollectOnlineLoading(state, loading) {
        state.collectOnlineLoading = loading
    },
    setDateRange(state, range) {
        state.dateRange = range
    },
    setVolumes(state, { formula }) {
        state.volumes = formula.volume
    },
    setLoadingVolumesToken(state, time) {
        state.loadingVolumesToken = time
    },
    setLoadingTaxonomyBreakdownToken(state, time) {
        state.loadingTaxonomyBreakdownToken = time
    },
    setLoadingVolumes(state, loading) {
        state.loadingVolumes = loading
    },
    setVolumesError(state, error) {
        state.volumesError = error
    },
    setTaxonomiesBreakdownAffinity: (state, affinity) => {
        state.taxonomiesBreakdownAffinity = affinity
    },
    setTaxonomiesBreakdownPurcent: (state, purcent) => {
        state.taxonomiesBreakdownPurcent = purcent
    },
    setTaxonomiesBreakdownLoading: (state, loading) => {
        state.taxonomiesBreakdownLoading = loading
    }
}

export default mutations